// ─── Selector de operarios del equipo al duplicar la orden ───────────────────
// Se precarga con el equipo de la orden original (ver Api_ReporteAcondicionamientoModal.js)
// y el administrador puede ajustarlo antes de crear la orden duplicada.
window.selectorEquipoDuplicarAcondicionamiento = null;

document.addEventListener('DOMContentLoaded', function () {
    if (typeof window.iniciarSelectorEquipoAcondicionamiento !== 'function') return;
    if (!document.getElementById('formDuplicarOrdenAcondicionamiento')) return;

    window.selectorEquipoDuplicarAcondicionamiento = window.iniciarSelectorEquipoAcondicionamiento({
        idFiltro: 'filtroOperarioDuplicarAcondicionamiento',
        idFiltroArea: 'filtroAreaDuplicarAcondicionamiento',
        idResultados: 'resultadosOperariosDuplicarAcondicionamiento',
        idSeleccionados: 'seleccionadosEquipoDuplicarAcondicionamiento',
        idInputs: 'inputsEquipoDuplicarAcondicionamiento'
    });
});

document.addEventListener('submit', async function (e) {
    if (e.target.id !== 'formDuplicarOrdenAcondicionamiento') return;

    e.preventDefault();

    const formulario = e.target;
    const modalPadre = formulario.closest('.modal');
    const btnSubmit = formulario.querySelector('#btnDuplicarOrdenAcondicionamiento');
    const spinner = formulario.querySelector('#spinner');

    if (!formulario.checkValidity()) {
        formulario.reportValidity();
        return;
    }

    if (window.selectorEquipoDuplicarAcondicionamiento && window.selectorEquipoDuplicarAcondicionamiento.contar() === 0) {
        if (typeof lanzarAlerta === 'function') {
            lanzarAlerta('Debes seleccionar al menos un operario para el equipo de trabajo.', 'alerta-roja');
        }
        return;
    }

    if (btnSubmit) btnSubmit.disabled = true;
    if (spinner) spinner.style.display = 'inline-block';

    formulario.querySelectorAll('.inputRojo').forEach(function (input) {
        input.classList.remove('inputRojo');
    });

    try {
        const formData = new FormData(formulario);

        const respuesta = await fetch('/api/acondicionamiento/duplicar', {
            method: 'POST',
            body: formData,
            credentials: 'include'
        });

        const json = await respuesta.json();

        if (!respuesta.ok || !json || !json.result) {
            if (typeof lanzarAlerta === 'function') lanzarAlerta('Error al procesar la solicitud.', 'alerta-roja');
            return;
        }

        const resultado = json.result;

        if (resultado.hayErrores) {
            if (Array.isArray(resultado.errores)) {
                resultado.errores.forEach(function (error) {
                    if (typeof lanzarAlerta === 'function') {
                        lanzarAlerta(error.mensaje || 'Error de validación.', error.clase || 'alerta-roja');
                    }
                    if (error.campo) {
                        const campo = formulario.querySelector('[name="' + error.campo + '"]');
                        if (campo) campo.classList.add('inputRojo');
                    }
                });
            }
            return;
        }

        formulario.reset();

        if (window.selectorEquipoDuplicarAcondicionamiento) {
            window.selectorEquipoDuplicarAcondicionamiento.limpiar();
        }

        if (modalPadre) modalPadre.classList.remove('modal--show');

        const params = new URLSearchParams(window.location.search);
        if (typeof window.actualizarTablaAcondicionamientoPeriodo === 'function') {
            window.actualizarTablaAcondicionamientoPeriodo(params.get('mes'), params.get('año'));
        }

        if (typeof lanzarAlerta === 'function') {
            lanzarAlerta('Orden de trabajo duplicada con éxito.', 'alerta-verde');
        }

    } catch (error) {
        console.error('Error:', error);
        if (typeof lanzarAlerta === 'function') {
            lanzarAlerta('Error crítico al procesar la solicitud.', 'alerta-roja');
        } else {
            alert('Error crítico al procesar la solicitud.');
        }
    } finally {
        if (btnSubmit) btnSubmit.disabled = false;
        if (spinner) spinner.style.display = 'none';
    }
});
